import { render } from "./CampaignsManagementDetailsHeader.vue?vue&type=template&id=7fc51548"
import script from "./CampaignsManagementDetailsHeader.vue?vue&type=script&lang=js"
export * from "./CampaignsManagementDetailsHeader.vue?vue&type=script&lang=js"

import "./CampaignsManagementDetailsHeader.vue?vue&type=style&index=0&id=7fc51548&lang=scss"
import "./CampaignsManagementDetailsHeader.vue?vue&type=style&index=1&id=7fc51548&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__